export default "__VITE_PUBLIC_ASSET__04ab7b75__"